import React from 'react'

const StatusBadge = ({ status, type = 'quotation' }) => {
  const getQuotationStatusConfig = (statusId) => {
    const configs = {
      1: { label: 'Rascunho', color: 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600', icon: '📝' },
      2: { label: 'Ativa', color: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-400 border-blue-300 dark:border-blue-700', icon: '🔵' },
      3: { label: 'Fechada', color: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400 border-green-300 dark:border-green-700', icon: '✅' },
      4: { label: 'Cancelada', color: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-400 border-red-300 dark:border-red-700', icon: '❌' },
      5: { label: 'Expirada', color: 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-400 border-orange-300 dark:border-orange-700', icon: '⏰' }
    }
    return configs[statusId] || configs[1]
  }

  const getSupplierStatusConfig = (statusId) => {
    const configs = {
      1: { label: 'Pendente', color: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-400 border-yellow-300 dark:border-yellow-700', icon: '⏳' },
      2: { label: 'Visualizada', color: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-400 border-blue-300 dark:border-blue-700', icon: '👁️' },
      3: { label: 'Em Andamento', color: 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-400 border-indigo-300 dark:border-indigo-700', icon: '⚙️' },
      4: { label: 'Respondida', color: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400 border-green-300 dark:border-green-700', icon: '✅' },
      5: { label: 'Recusada', color: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-400 border-red-300 dark:border-red-700', icon: '❌' },
      6: { label: 'Expirada', color: 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-400 border-orange-300 dark:border-orange-700', icon: '⏰' }
    }
    return configs[statusId] || configs[1]
  }

  const config = type === 'quotation' 
    ? getQuotationStatusConfig(status) 
    : getSupplierStatusConfig(status)

  return (
    <span className={`inline-flex items-center gap-1 px-3 py-1 text-sm font-medium rounded-full border transition-colors ${config.color}`}>
      <span className="text-xs">{config.icon}</span>
      {config.label}
    </span>
  )
}

export default StatusBadge
